/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreatedPublicApiKeyResponse
 */
export interface CreatedPublicApiKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof CreatedPublicApiKeyResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedPublicApiKeyResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedPublicApiKeyResponse
     */
    clientName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreatedPublicApiKeyResponse
     */
    tenantId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatedPublicApiKeyResponse
     */
    scopes: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof CreatedPublicApiKeyResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatedPublicApiKeyResponse
     */
    expiresAt: Date | null;
}

/**
 * Check if a given object implements the CreatedPublicApiKeyResponse interface.
 */
export function instanceOfCreatedPublicApiKeyResponse(value: object): value is CreatedPublicApiKeyResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function CreatedPublicApiKeyResponseFromJSON(json: any): CreatedPublicApiKeyResponse {
    return CreatedPublicApiKeyResponseFromJSONTyped(json, false);
}

export function CreatedPublicApiKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedPublicApiKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'key': json['key'],
        'clientName': json['clientName'],
        'tenantId': ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
        'scopes': json['scopes'],
        'createdAt': (new Date(json['createdAt'])),
        'expiresAt': (json['expiresAt'] == null ? null : new Date(json['expiresAt'])),
    };
}

export function CreatedPublicApiKeyResponseToJSON(json: any): CreatedPublicApiKeyResponse {
    return CreatedPublicApiKeyResponseToJSONTyped(json, false);
}

export function CreatedPublicApiKeyResponseToJSONTyped(value?: CreatedPublicApiKeyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'key': value['key'],
        'clientName': value['clientName'],
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
        'scopes': value['scopes'],
        'createdAt': value['createdAt'].toISOString(),
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
    };
}

